import { useState, useEffect } from 'react';

export const useIsAuthenticated = () => {
  const [state, setState] = useState<{
    isAuthenticated: boolean;
    initialized: boolean;
    validating: boolean;
  }>({
    isAuthenticated: false,
    initialized: false,
    validating: true,
  });

  useEffect(() => {
    // Wait a tick to allow TokenHandler to run first
    const timeout = setTimeout(() => {
      const token = localStorage.getItem('access_token');
      setState({
        isAuthenticated: !!token,
        initialized: true,
        validating: false,
      });
    }, 200);

    // 200ms delay

    const handleStorageChange = () => {
      setState(prev => ({ ...prev, validating: true }));
      setTimeout(() => {
        const token = localStorage.getItem('access_token');
        // Only update if the value actually changed
        setState(prev => {
          const isAuthenticated = !!token;
          if (
            prev.isAuthenticated === isAuthenticated &&
            prev.initialized === true &&
            prev.validating === false
          ) {
            return prev;
          }
          return {
            isAuthenticated,
            initialized: true,
            validating: false,
          };
        });
      }, 100);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return state;
};
